const IS_DEVEL = process.env.NODE_ENV === 'development';

export { IS_DEVEL };
